module.exports = __webpack_public_path__ + "static/img/crx-monogram.1e65fdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crx-monogram.png
// module id = wwSf
// module chunks = 1